module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp3-02-8a9e2982c736af16bed6252e3c78476f.png";